var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopBottomFive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "235px",
    height: "125px",
    viewBox: "0 0 235 125",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Widget/Data/TeamPerformance/Simplified") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "top-bottom-5-path-1",
    x: 0,
    y: 0,
    width: 235,
    height: 125,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,103.863549 C80.718807,103.863549 104,80.6129016 104,51.9317745 C104,23.2506474 80.718807,0 52,0 C23.281193,0 0,23.2506474 0,51.9317745 C0,80.6129016 23.281193,103.863549 52,103.863549 Z",
    id: "top-bottom-5-path-3"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "top-bottom-5-mask-4",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 104,
    height: 103.863549,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#top-bottom-5-path-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.8,89.4824423 C69.5423568,89.4824423 89.6,69.4511152 89.6,44.7412211 C89.6,20.031327 69.5423568,0 44.8,0 C20.0576432,0 0,20.031327 0,44.7412211 C0,69.4511152 20.0576432,89.4824423 44.8,89.4824423 Z",
    id: "top-bottom-5-path-5"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "top-bottom-5-mask-6",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 89.6,
    height: 89.4824423,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#top-bottom-5-path-5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Widget/Data/TeamPerformance/Simplified",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "top-bottom-5-mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#top-bottom-5-path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#top-bottom-5-path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Doughnut-Copy",
    mask: "url(#top-bottom-5-mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(121.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outer-Circle"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#E5E6E5",
    strokeWidth: 7.2,
    transform: "translate(52.000000, 51.931775) scale(-1, 1) rotate(-180.000000) translate(-52.000000, -51.931775) ",
    cx: 52,
    cy: 51.9317745,
    rx: 48.4,
    ry: 48.3317745
  }), /*#__PURE__*/React.createElement("use", {
    id: "Oval",
    stroke: "#2E5799",
    mask: "url(#top-bottom-5-mask-4)",
    strokeWidth: 14.4,
    strokeDasharray: 311.2,
    transform: "translate(52.000000, 51.931775) scale(-1, 1) rotate(-180.000000) translate(-52.000000, -51.931775) ",
    xlinkHref: "#top-bottom-5-path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Inner-Circle",
    transform: "translate(7.200000, 7.190553)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#E5E6E5",
    strokeWidth: 7.2,
    transform: "translate(44.800000, 44.741221) scale(-1, 1) rotate(-180.000000) translate(-44.800000, -44.741221) ",
    cx: 44.8,
    cy: 44.7412211,
    rx: 41.2,
    ry: 41.1412211
  }), /*#__PURE__*/React.createElement("use", {
    id: "Oval",
    stroke: "#66CCBB",
    mask: "url(#top-bottom-5-mask-6)",
    strokeWidth: 14.4,
    strokeDasharray: 236,
    transform: "translate(44.800000, 44.741221) scale(-1, 1) rotate(-180.000000) translate(-44.800000, -44.741221) ",
    xlinkHref: "#top-bottom-5-path-5"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#979797",
    mask: "url(#top-bottom-5-mask-2)",
    x: 9.5,
    y: 16.5,
    width: 94,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    stroke: "#979797",
    mask: "url(#top-bottom-5-mask-2)",
    x: 9.5,
    y: 39.5,
    width: 94,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    stroke: "#979797",
    mask: "url(#top-bottom-5-mask-2)",
    x: 9.5,
    y: 62.7431153,
    width: 94,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    stroke: "#979797",
    mask: "url(#top-bottom-5-mask-2)",
    x: 9.5,
    y: 85.8646729,
    width: 94,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    stroke: "#979797",
    mask: "url(#top-bottom-5-mask-2)",
    x: 9.5,
    y: 108.986231,
    width: 94,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    fill: "#2E5799",
    mask: "url(#top-bottom-5-mask-2)",
    x: 9,
    y: 22,
    width: 12,
    height: 12,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    fill: "#2E5799",
    mask: "url(#top-bottom-5-mask-2)",
    x: 9,
    y: 45,
    width: 12,
    height: 12,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    fill: "#2E5799",
    mask: "url(#top-bottom-5-mask-2)",
    x: 9,
    y: 68,
    width: 12,
    height: 12,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    fill: "#2E5799",
    mask: "url(#top-bottom-5-mask-2)",
    x: 9,
    y: 91,
    width: 12,
    height: 12,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    mask: "url(#top-bottom-5-mask-2)",
    x: 28,
    y: 23,
    width: 49,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    fill: "#D8D8D8",
    mask: "url(#top-bottom-5-mask-2)",
    x: 28,
    y: 46,
    width: 49,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    fill: "#D8D8D8",
    mask: "url(#top-bottom-5-mask-2)",
    x: 84,
    y: 23,
    width: 20,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-11",
    fill: "#D8D8D8",
    mask: "url(#top-bottom-5-mask-2)",
    x: 84,
    y: 46,
    width: 20,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    fill: "#D8D8D8",
    mask: "url(#top-bottom-5-mask-2)",
    x: 28,
    y: 69,
    width: 49,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    fill: "#D8D8D8",
    mask: "url(#top-bottom-5-mask-2)",
    x: 84,
    y: 69,
    width: 20,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-15",
    fill: "#D8D8D8",
    mask: "url(#top-bottom-5-mask-2)",
    x: 28,
    y: 92,
    width: 49,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-14",
    fill: "#D8D8D8",
    mask: "url(#top-bottom-5-mask-2)",
    x: 84,
    y: 92,
    width: 20,
    height: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopBottomFive);
export default __webpack_public_path__ + "static/media/top-bottom-five.23932153af6023e0145282df233e8d8b.svg";
export { ForwardRef as ReactComponent };